module.exports = __webpack_public_path__ + "static/letusgonewlogo-a79447c1924df57a7a333e251f7d6ba5.svg";